import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Bet_on_football_specials_with__ELL,
  TXTWCL_Football_Specials_Betting_X_Fo_ELL
} from './sportsAnimalRacingSpecials.messages.json';

const sportsAnimalRacingSpecialsWidgets = [
  {
    title: 'Sports CMS Banner Widget',
    _content_type_uid: SportsWidgetType.SportsCmsBanner,
    boxShadow: false
  },
  {
    title: 'Sports Event Type Info Widget',
    _content_type_uid: SportsWidgetType.SportsEventTypeInfo
  },
  {
    title: 'Sports Animal Racing Specials Page Widget',
    _content_type_uid: SportsWidgetType.SportsAnimalRacingSpecialsPage
  }
] satisfies readonly SectionWidgetConfig[];

// TODO - GSFE-2956 - update SEO tags
export const sportsAnimalRacingSpecials = buildSportsLayoutPageResponse({
  alias: 'sportsAnimalRacingSpecials',
  seoConfig: {
    apiPath: '/meta/event-type/',
    descriptionTag: TXTWCL_Bet_on_football_specials_with__ELL,
    redirectTo: 'sportsHome',
    redirectStatusCode: 302,
    titleTag: TXTWCL_Football_Specials_Betting_X_Fo_ELL
  },
  mainSectionWidgetConfigs: sportsAnimalRacingSpecialsWidgets
});
